/* eslint-disable prettier/prettier */
export const section = [
  'w-full flex flex-col items-center bg-[#1A1726]'
].join(' ');

export const Wrapper = [
  'flex flex-col items-center',
  'gap-[3.25rem] max-w-[23.438rem] pt-[4rem] gap-8 px-4 pb-[5rem]',
  'md:max-w-[90rem] md:pt-[7.5rem] md:gap-[4rem] md:px-0'
].join(' ');
